import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart } from '@fortawesome/pro-solid-svg-icons/faHeart';
import { faHeart as faHeartRegular } from '@fortawesome/pro-regular-svg-icons/faHeart';

import { Button, ButtonType } from '../Button';

export interface AvatarFavoriteButtonProps {
  isFavorite: boolean;
  onToggle: () => void;
  ariaLabel?: string;
  id?: string;
}

export const AvatarFavoriteButton = ({
  isFavorite,
  onToggle,
  ariaLabel,
  id,
}: AvatarFavoriteButtonProps): JSX.Element => (
  <Button
    id={id}
    buttonType={ButtonType.tertiary}
    aria-label={ariaLabel ?? (isFavorite ? 'Remove from favorites' : 'Save as favorite')}
    onClick={onToggle}
    className={
      '!absolute -bottom-1 -right-1 bg-white !rounded-full !w-8 !h-8 !min-w-0 !p-0 aspect-square leading-none '
      + 'flex items-center justify-center border border-neutral-300 shadow '
      + (isFavorite ? 'text-bubblegum' : 'text-neutral-500')
    }
  >
    <FontAwesomeIcon icon={isFavorite ? faHeart : faHeartRegular} />
  </Button>
);
